import { Serializable } from '@/models/core/serializable';

export class ReportZipUrl implements Serializable<ReportZipUrl> {
  evalSettingID: number;
  url: string;
  simpleZipURL: string;

  deserialize(input: any): ReportZipUrl {
    this.evalSettingID = input.evalSettingID;
    this.url = input.url;
    this.simpleZipURL = input.simpleZipURL;

    return this;
  }
}
